import script from "./ComHuonekorttiNimikeHistoriaItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekorttiNimikeHistoriaItem.vue?vue&type=script&setup=true&lang=ts"

import "./ComHuonekorttiNimikeHistoriaItem.vue?vue&type=style&index=0&id=192285c3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-192285c3"]])

export default __exports__